"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface LeaseLiabilitySubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Lease Liability - Ind AS";

export default function LeaseLiabilitySubstantive({ onBack, setActiveSection }: LeaseLiabilitySubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
